import { render, staticRenderFns } from "./DynamicListTemplatesPage.vue?vue&type=template&id=812b80aa&scoped=true"
import script from "./DynamicListTemplatesPage.vue?vue&type=script&lang=ts"
export * from "./DynamicListTemplatesPage.vue?vue&type=script&lang=ts"
import style0 from "./DynamicListTemplatesPage.vue?vue&type=style&index=0&id=812b80aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812b80aa",
  null
  
)

export default component.exports